import isUrl from 'is-url';
import React, { useState } from 'react';
import { Editor, Range } from 'slate';
import { ReactEditor } from 'slate-react';

import { clearEditorMenu } from '../../../../actions/clearEditorMenu';
import { useDispatch } from '../../../../redux';
import { insertLinkElement } from '../internal/withLinks';
import { LinkEdit } from './LinkEdit';

type Props = {
  editor: ReactEditor;
  selection: Range;
};

type State = {
  url: string;
  text: string;
};

export const NewLinkContainter = ({ editor, selection }: Props): React.ReactElement => {
  const [state, setState] = useState<State>(() => {
    if (Range.isCollapsed(selection)) {
      return {
        url: '',
        text: '',
      };
    } else {
      const text = Editor.string(editor, selection);

      return {
        url: isUrl(text) ? text : '',
        text: Editor.string(editor, selection),
      };
    }
  });
  const dispatch = useDispatch();
  const { text, url } = state;

  return (
    <LinkEdit
      value={{ text, url }}
      onChange={(value): void => {
        setState((state) => ({ ...state, ...value }));
      }}
      onSave={(): void => {
        insertLinkElement(editor, { selection, text, url });
        ReactEditor.focus(editor);
        dispatch(clearEditorMenu());
      }}
    />
  );
};
